

import { useState, useEffect } from "react";
import { X } from "lucide-react";
import axios from "axios";
import Cookies from "js-cookie";
import { createPortal } from "react-dom";

export default function AddInventoryModal({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    // item_type: "",
    item_type_id: "",

    item_units: 1,
    status: "Assignable",
    vendor_name: "",
    v_mobile_no: "",
    invoice_image: null,
    item_image: null, // ✅ NEW
    purchase_date: "",
    warranty_date: "",
    additional_info: "",
  });







  const [itemTypes, setItemTypes] = useState([]);


  useEffect(() => {
    const fetchItemTypes = async () => {
      try {
        const token = Cookies.get("token");
  
        const res = await axios.get(
          "https://uptask.visiontrek.io/api/inventory/types",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
  
        setItemTypes(res.data?.data || []);
      } catch (err) {
        console.error("Failed to load item types");
      }
    };
  
    if (isOpen) {
      fetchItemTypes();
    }
  }, [isOpen]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "auto";
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };




  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
  
    try {
      const token = Cookies.get("token");
  
      const data = new FormData();
  
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });
  
      await axios.post(
        "https://uptask.visiontrek.io/api/inventory/",
        // "https://192.168.1.16:5555/api/inventory/",
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      onClose();
    } catch {
      setError("Failed to add inventory");
    } finally {
      setLoading(false);
    }
  };






  if (!isOpen) return null;






 

  return createPortal(
    <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
      <div className="
        relative z-[10000]
        w-full max-w-4xl max-h-[85vh]
        rounded-2xl
        bg-white/15 backdrop-blur-xl
        shadow-2xl border border-white/20
        text-white
        overflow-hidden
      ">

        {/* Header */}
        <div className="
          flex justify-between items-center px-6 py-4
          bg-gradient-to-r from-[#2d1c6a] to-[#24155a]
        ">
          <h2 className="font-semibold text-lg">
            Add Inventory Item
          </h2>
          <X
            size={22}
            onClick={onClose}
            className="cursor-pointer text-white/80 hover:text-red-300"
          />
        </div>

        {/* Body */}
        <form
          onSubmit={handleSubmit}
          className="p-6 overflow-y-auto max-h-[calc(85vh-70px)] space-y-4"
        >
          {error && (
            <div className="bg-red-500/20 text-red-300 p-3 rounded text-sm">
              {error}
            </div>
          )}

      






          <div className="grid grid-cols-2 gap-4">

{/* Item Name */}
<div>
  <label className="text-sm text-white/80">Item Name</label>
  <input name="name" onChange={handleChange}
    className="w-full bg-white/10 border border-white/20 p-2 rounded mt-1" />
</div>

{/* Item Type Dropdown */}
<div>
  <label className="text-sm text-white/80">Item Type</label>



<select
  name="item_type_id"
  value={formData.item_type_id}
  onChange={handleChange}
  className="w-full bg-white text-black p-2 rounded mt-1"
>
  <option value="" className="bg-white text-black">Select Item Type</option>

  {itemTypes.map((type) => {
    console.log("TYPE:", type); // 👈 check this

    return (
      <option key={type.id} value={type.id} className="bg-white text-black">
        {type.name || type.type || type.item_type}
      </option>
    );
  })}
</select>
</div>

{/* Units */}
<div>
  <label className="text-sm text-white/80">Units</label>
  <input type="number" name="item_units"
    onChange={handleChange}
    className="w-full bg-white/10 border border-white/20 p-2 rounded mt-1" />
</div>

{/* Status */}
<div>
  <label className="text-sm text-white/80">Status</label>
  <select name="status" onChange={handleChange}
    className="w-full bg-white text-gray-800 p-2 rounded mt-1">
    {/* <option>Idle</option>
    <option>In Use</option> */}
    <option>Assignable</option>

<option>Not Assignable</option>
  </select>
</div>

{/* Vendor */}
<div>
  <label className="text-sm text-white/80">Vendor Name</label>
  <input name="vendor_name"
    onChange={handleChange}
    className="w-full bg-white/10 border border-white/20 p-2 rounded mt-1" />
</div>

{/* Mobile */}
<div>
  <label className="text-sm text-white/80">Vendor Mobile</label>
  <input name="v_mobile_no"
    onChange={handleChange}
    className="w-full bg-white/10 border border-white/20 p-2 rounded mt-1" />
</div>

{/* Invoice Image */}
<div>
  <label className="text-sm text-white/80">Invoice Image</label>
  <input type="file"
    onChange={(e) =>
      setFormData((p) => ({ ...p, invoice_image: e.target.files[0] }))
    }
    className="w-full bg-white/10 border border-white/20 p-2 rounded mt-1"
  />
</div>

{/* Item Image */}
<div>
  <label className="text-sm text-white/80">Item Image</label>
  <input type="file"
    onChange={(e) =>
      setFormData((p) => ({ ...p, item_image: e.target.files[0] }))
    }
    className="w-full bg-white/10 border border-white/20 p-2 rounded mt-1"
  />
</div>

{/* Purchase Date */}
<div>
  <label className="text-sm text-white/80">Purchase Date</label>
  <input type="date" name="purchase_date"
    onChange={handleChange}
    className="w-full bg-white text-gray-800 p-2 rounded mt-1" />
</div>

{/* Warranty */}
<div>
  <label className="text-sm text-white/80">Warranty Date</label>
  <input type="date" name="warranty_date"
    onChange={handleChange}
    className="w-full bg-white text-gray-800 p-2 rounded mt-1" />
</div>

</div>





          <textarea
            name="additional_info"
            placeholder="Additional Info"
            onChange={handleChange}
            className="w-full bg-white/10 border border-white/20 p-2 rounded"
          />

          <div className="flex justify-end gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-white/10 rounded"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={loading}
              className="px-6 py-2 bg-purple-600 rounded"
            >
              {loading ? "Saving..." : "Add Item"}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}
